import React, { useEffect, useState } from "react";
import { Flex, Text, RadioGroup, Heading } from "@radix-ui/themes";
import { IPollOption } from "../../../models/Task";

interface Option {
  id: string;
  answerValue: string;
  isAnswer: boolean;
}

interface MultiChoicePollProps {
  onCheck: (option: IPollOption, index: number) => void;
  question: string;
  index: number;
  options: IPollOption[];
  isMandatory: boolean;
  onValidate?: (index: number, isValid: boolean) => void;

}

const SingleChoicePoll: React.FC<MultiChoicePollProps> = ({
  question,
  options,
  index,
  onCheck,
  isMandatory,
  onValidate,

}) => {

  const [defaultValue, setDefault] = useState<string>('');

  useEffect(() => {
    if (onValidate && isMandatory) {
      onValidate(index, options.some((opt) => opt.isSelected));
    }
    options.forEach((el) => {
      if (el.isSelected) {
        setDefault(el.option);
      }
    });
  }, [options, index, onValidate, isMandatory]);

  const selectedValue = options.find((el) => el.isSelected)?.option || '';

  const handleOnCheck = (value: string) => {
    const selectedOption = options.find((el) => el.option === value);
    if (selectedOption) {
      onCheck(selectedOption, index);
      if (onValidate && isMandatory) {
        onValidate(index, true); 
      }
    }
  };

  return (
    <Flex direction="column" gap="5">
      <Heading>{question}</Heading>
      <RadioGroup.Root
        value={selectedValue} // Controlled value
        onValueChange={handleOnCheck} // Handle changes
      >
        <Flex gap="2" direction="column">
          {options.map((el) => (
            <Text
              key={el.id}
              className="border-2 max-w-sm p-3 text-black font-semibold my-2 rounded-lg shadow-sm"
              as="label"
              size="2"
            >
              <Flex gap="2" className="space-x-2">
                <RadioGroup.Item value={el.option} />
                <Text>{el.option}</Text>
              </Flex>
            </Text>
          ))}
        </Flex>
      </RadioGroup.Root>
    </Flex>
  );
};

export default SingleChoicePoll;
